import { makeAutoObservable, runInAction } from 'mobx';

import {
  frontApi,
  API_ROUTES
} from '_app/api';
// import toast from 'utils/toast';

export class RolesStore {
  constructor() {
    makeAutoObservable(this);
  }

  isLoading = false;

  roles = [];

  errors = {};

  fetchRoles = async () => {
    try {
      const { data } = await frontApi(API_ROUTES.roles);

      runInAction(() => {
        this.roles = data;
      });

    } catch (error) {
      console.error(error);
    }
  };
}

export default new RolesStore();
